export default {
	COMMAND_RESPONSE: 'command-response',
	LIVE_STREAMING: 'live-streaming',
};
